export function applyBackgroundColor (cellElement, cellParams) {
  if (!cellParams.columnDef?.backgroundColor) return

  const color = cellParams.columnDef.backgroundColor(cellParams)

  cellElement.style['background-color'] = color
}
